<template>
	<div class="video-player-container">

		<video ref="VideoJSPlayer" preload="auto" class="video-js  safari-player" controls></video>

		<div v-if="showqueryDetails" class="queryDetailContainer">
			<p>Something Wrong?Tell Us.</p>
		</div>

		<div v-if="showSubtitleDetails" class="subtitleDetailContainer">
			<p>Subtitles and Multi-language</p>
			<p>Features are coming soon</p>
		</div>

	</div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-eme";
import Castjs from "@/assets/js/Cast.js";
import("videojs-hls-quality-selector");
import "videojs-contrib-quality-levels";
export default {
	name: "NewVideoJsPlayer",
	props: ["safariPlayback", "customData", "playback", "vid"],

	data() {
		return {
			player: null,
			showCastVideoNotification: false,
			videoDetails: null,
			currentVideoName: null,
			showCastingOn: false,
			lastPlayerSeekedTime: null,
			isPlaybackEnded: false,
			videoid: null,
			showSubtitleDetails: false,
			showqueryDetails: false,
		};
	},
	mounted() {
		this.videoid = this.$route.params.vid;
		var options = {
			fluid: true,
			enableLowInitialPlaylist: true,
			playbackRates: [0.5, 1, 1.5, 2],
			plugins: {
				qualityLevels: {},
			},
			controlBar: {
				skipButtons: {
					backward: 10,
					forward: 5,
					forwardIndex: 1,
					backIndex: 1
				},
				remainingTimeDisplay: {
					displayNegative: false
				},
				volumePanel: {
					inline: false,
					vertical: true,
				},

			},
		};
		this.player = videojs(this.$refs.VideoJSPlayer, options, () => {
			this.player.hlsQualitySelector({
				displayCurrentQuality: true,
			});
		});
		var license = "https://lic.drmtoday.com/license-server-fairplay/";
		var cert = "https://lic.drmtoday.com/license-server-fairplay/cert/ibakatv";
		var stream = this.playback;

		this.player.eme();
		this.player.src({
			src: stream,
			type: "application/x-mpegURL",
			keySystems: {

			},
		});
		this.generateControllbarBtn();

		this.player.on("play", () => {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in the cast device"
				);
			}
			let fullscreenOrNot = this.player.isFullscreen();
			if (fullscreenOrNot) {
				screen.orientation.lock("landscape");
			}
			else {
				screen.orientation.lock("portrait");
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.play();
			}
		});
		this.player.on("pause", () => {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in the cast device"
				);
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.pause();
			}
		});

		this.player.on("seeked", () => {
			let playerCurrentTime = Math.floor(this.player.currentTime());
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.seek(playerCurrentTime);
			}
		});
		this.player.on("volumechange", () => {
			let playerCurrentVolumeTime = this.player.volume();
			if (this.playermuted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.mute();
				}
			}
			if (!this.player.muted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.unmute();
				}
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.volume(playerCurrentVolumeTime);
			}
		});
		document.addEventListener("fullscreenchange", this.handleFullscreenOrientation);

		this.player.on("ended", () => {
			this.isPlaybackEnded = true;
			var DataToSend = {};
			DataToSend["video_id"] = this.videoid;
			DataToSend["status"] = 0;
			DataToSend["resumeTime"] = 0;
			this.$store.dispatch("setResumeVideo", DataToSend);
			this.$router.go(-1);
		});


		if (this.player) {
			if (this.$route.query.resume == "true") {
				this.$store.dispatch("getResumeVideo").then((res) => {
					setTimeout(() => {
						const resumeVideo = res.resumeList.find(
							(element) => element.video_id === this.videoid
						);
						if (resumeVideo) {
							const seekTime = this.player.seek(resumeVideo.resumeTime);
						}

						self.$store.commit("setLoader", false);
					}, 1000);
				});
			} else {
				this.$store.commit("setLoader", false);
			}
		}

		this.$store.dispatch("getVideoById", this.$route.params.vid).then((res) => {
			this.videoDetails = res._embedded.collections[0];
			if (this.videoDetails) {
				this.currentVideoName = this.videoDetails.name;
				this.addNameButton(this.currentVideoName);
			} else {
				this.currentVideoName = " ";
			}
		});
		const isCastingOn = this.$store.getters.getIsCastingOn;
		if (isCastingOn) {
			this.loadDefaultCast();
		}

	},

	methods: {
		handleBack() {
			var DataToSend = {};
			DataToSend["video_id"] = this.videoid;
			DataToSend["status"] = 1;
			DataToSend["resumeTime"] = Math.trunc(this.player.currentTime());
			if (this.isPlaybackEnded == false) {
				this.$store.dispatch("setResumeVideo", DataToSend).then(() => {
					this.$store.dispatch("getResumeVideo");
				});
			}
			this.player = null;
			document.exitFullscreen();
			history.back();
		},
		seekForward() {
			const currentTime = this.player.currentTime();
			console.log("timef", currentTime + 10)
			this.player.currentTime(currentTime + 10);


		},
		seekRewind() {
			const currentTime = this.player.currentTime();
			console.log("timef", currentTime - 10)
			this.player.currentTime(currentTime - 10);

		},
		base64DecodeUint8Array(input) {
			var raw = window.atob(input);
			var rawLength = raw.length;
			var array = new Uint8Array(new ArrayBuffer(rawLength));

			for (i = 0; i < rawLength; i++) array[i] = raw.charCodeAt(i);

			return array;
		},

		base64EncodeUint8Array(input) {
			var keyStr =
				"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
			var output = "";
			var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
			var i = 0;

			while (i < input.length) {
				chr1 = input[i++];
				chr2 = i < input.length ? input[i++] : Number.NaN;
				chr3 = i < input.length ? input[i++] : Number.NaN;

				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;

				if (isNaN(chr2)) {
					enc3 = enc4 = 64;
				} else if (isNaN(chr3)) {
					enc4 = 64;
				}
				output +=
					keyStr.charAt(enc1) +
					keyStr.charAt(enc2) +
					keyStr.charAt(enc3) +
					keyStr.charAt(enc4);
			}
			return output;
		},
		Utf8ArrayToStr(array) {
			var out, i, len, c;
			var char2, char3;

			out = "";
			len = array.length;
			i = 0;
			while (i < len) {
				c = array[i++];
				switch (c >> 4) {
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
					case 6:
					case 7:
						// 0xxxxxxx
						out += String.fromCharCode(c);
						break;
					case 12:
					case 13:
						// 110x xxxx   10xx xxxx
						char2 = array[i++];
						out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
						break;
					case 14:
						// 1110 xxxx  10xx xxxx  10xx xxxx
						char2 = array[i++];
						char3 = array[i++];
						out += String.fromCharCode(
							((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
						);
						break;
				}
			}

			return out;
		},
		sendRemotePlayer() {
			let cjs = this.$store.getters.getCjs;
			if (cjs == null) {
				cjs = new Castjs({
					receiver: "3726E1B7",
				});
				this.$store.commit("setCjs", cjs);
			}
			cjs.on("connect", () => {
				this.$store.commit("setNotification", `Connected to ${cjs.device}`);
				this.$store.commit("setIsCastingOn", true);
				this.showCastingOn = true;
				this.player.pause();
				this.showCastVideoNotification = true;
			});
			if (cjs.available) {
				cjs.cast(this.playback, {}, { licenseHeader: this.customData });
			}
			cjs.on("playing", () => {
				let playerCurrentTime = Math.floor(this.player.currentTime());
				if (cjs != null && this.lastPlayerSeekedTime != playerCurrentTime) {
					this.lastPlayerSeekedTime = playerCurrentTime
					cjs.seek(playerCurrentTime);
				}
			});
			cjs.on("disconnect", () => {
				this.$store.commit(
					"setNotification",
					`DisConnected from ${cjs.device}`
				);
				this.lastPlayerSeekedTime = null;
				this.showCastingOn = false;
				this.$store.commit("setIsCastingOn", false);
				this.showCastVideoNotification = false;
			});
		},
		castNotification() {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in cast device"
				);
			}
		},
		loadDefaultCast() {
			var mediaInfo = new chrome.cast.media.MediaInfo(this.playback);
			mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
			this.version = "v4.1.2";
			//	this.receiver = opt.receiver;
			//	this.joinpolicy = opt.joinpolicy;
			//	this.available = false;
			//this.connected = false;
			this.device = "Chromecast";
			this.src = "";
			this.title = "";
			this.description = "";
			this.poster = "";
			this.subtitles = [];
			this.volumeLevel = 1;
			this.muted = false;
			this.paused = false;
			this.time = 0;
			this.timePretty = "00:00:00";
			this.duration = 0;
			this.durationPretty = "00:00:00";
			this.progress = 0;
			//this.state = "disconnected";
			// This part is the reason why people love this library ❤️
			if (this.subtitles.length) {
				// I'm using the Netflix subtitle styling
				// chrome.cast.media.TextTrackFontGenericFamily.CASUAL
				// chrome.cast.media.TextTrackEdgeType.DROP_SHADOW
				mediaInfo.textTrackStyle = new chrome.cast.media.TextTrackStyle();
				mediaInfo.textTrackStyle.backgroundColor = "#00000000";
				mediaInfo.textTrackStyle.edgeColor = "#00000016";
				mediaInfo.textTrackStyle.edgeType = "DROP_SHADOW";
				mediaInfo.textTrackStyle.fontFamily = "CASUAL";
				mediaInfo.textTrackStyle.fontScale = 1.0;
				mediaInfo.textTrackStyle.foregroundColor = "#FFFFFF";

				var tracks = [];
				for (var i in this.subtitles) {
					// chrome.cast.media.TrackType.TEXT
					// chrome.cast.media.TextTrackType.CAPTIONS
					var track = new chrome.cast.media.Track(i, "TEXT");
					track.name = this.subtitles[i].label;
					track.subtype = "CAPTIONS";
					track.trackContentId = this.subtitles[i].src;
					track.trackContentType = "text/vtt";
					// This bug made me question life for a while
					track.trackId = parseInt(i);
					tracks.push(track);
				}
				mediaInfo.tracks = tracks;
			}
			// Let's prepare the metadata
			mediaInfo.metadata.images = [new chrome.cast.Image(this.poster)];
			mediaInfo.metadata.title = this.title;
			mediaInfo.metadata.subtitle = this.description;
			mediaInfo.customData = { licenseHeader: this.customData };
			// Prepare the actual request
			var request = new chrome.cast.media.LoadRequest(mediaInfo);
			cast.framework.CastContext.getInstance()
				.getCurrentSession()
				.loadMedia(request)
				.then(
					() => {
						// Update device name
						this.device =
							cast.framework.CastContext.getInstance()
								.getCurrentSession()
								.getCastDevice().friendlyName || this.device;
						return this;
					},
					(err) => {
						return this.trigger("error", err);
					}
				);
		},
		isConnectedCastDevice() {
			if (this.showCastingOn) {
				return true;
			} else {
				return false;
			}
		},
		isPlatformMobile() {
			let check = false;
			(function (a) {
				if (
					/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
						a
					) ||
					/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
						a.substr(0, 4)
					)
				)
					check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);

			return check;
		},
		isPlatformTablet() {
			return (function (a) {
				if (/ipad|android.+\d safari|tablet/i.test(a)) return true;
			})(navigator.userAgent || navigator.vendor || window.opera)
				? "true"
				: "false";
		},

		isPlatformSafari() {
			let isSafari =
				navigator.vendor.match(/apple/i) &&
				!navigator.userAgent.match(/crios/i) &&
				!navigator.userAgent.match(/fxios/i) &&
				!navigator.userAgent.match(/Opera|OPT\//);

			if (isSafari) {
				return true;
			} else {
				return false;
			}
		},
		handleFullscreenOrientation(event) {
			if (this.player) {
				const fullscreenOrNot = this.player.isFullscreen();
				if (this.isPlatformMobile()) {
					if (fullscreenOrNot && screen.orientation) {
						screen.orientation.lock("landscape");
					}
					else if (screen.orientation) {
						screen.orientation.lock("portrait");
					}
				}
			}


		},

		showCastNotification() {
			if (this.isPlatformMobile() == true) {
				this.$store.commit(
					"setNotification",
					"Please download Ibakatv Mobile App to cast your device"
				);
			} else if (this.isPlatformTablet() == true) {
				this.$store.commit(
					"setNotification",
					"Please download Ibakatv Mobile App to cast your device"
				);
			} else if (this.isPlatformSafari() == true) {
				this.$store.commit(
					"setNotification",
					"Please use Google Chrome browser to cast"
				);
			}
			else {
				this.sendRemotePlayer()
			}
		},
		generateControllbarBtn() {
			var Button = videojs.getComponent('Button');
			var skipBackward = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-skipbackward-control');
					this.controlText("Rewind");
				},
				handleClick: () => {
					this.seekRewind()
				}
			});
			var skipForward = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-skipforward-control');
					this.controlText("Forward");
				},
				handleClick: () => {
					this.seekForward()
				}
			});
			var chromeCast = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-chromecast-control');
					this.controlText("Cast");
				},
				handleClick: () => {
					this.showCastNotification()
				}
			});

			var questionBtn = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-questionbtn-control');
					this.controlText("Query");
				},
				handleClick: () => {
					this.queryDetails()
				}
			});
			var subtitleBtn = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-subtitle-control');
					this.controlText("Subtitle");
				},
				handleClick: () => {
					this.subtitleDetails()
				}
			});
			var backBtn = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-backbtn-control');
					this.controlText("Back");
				},
				handleClick: () => {
					this.handleBack()
				}
			});


			videojs.registerComponent('skipBackward', skipBackward);
			videojs.registerComponent('skipForward', skipForward);
			videojs.registerComponent('chromeCast', chromeCast);
			videojs.registerComponent('questionBtn', questionBtn);
			videojs.registerComponent('subtitleBtn', subtitleBtn);
			videojs.registerComponent('backBtn', backBtn);

			this.player.getChild('controlBar').addChild('skipBackward', {}, 1);
			this.player.getChild('controlBar').addChild('skipForward', {}, 2);
			this.player.getChild('controlBar').addChild('chromeCast', {}, 12);
			this.player.getChild('controlBar').addChild('questionBtn', {}, 10);
			this.player.getChild('controlBar').addChild('subtitleBtn', {}, 11);
			this.player.getChild('controlBar').addChild('backBtn', {}, 13);

		},
		addNameButton(videoName) {
			var Button = videojs.getComponent('Button');

			var movieName = videojs.extend(Button, {
				constructor: function () {
					Button.apply(this, arguments);
					this.addClass('vjs-movienamebtn-control');
					this.controlText("Movie");
					this.el().innerText = videoName;

				},
				handleClick: () => {
					// this.handleBack()
				}
			});
			videojs.registerComponent('moviename', movieName);

			this.player.getChild('controlBar').addChild('moviename', {}, 4);

		},
		subtitleDetails() {
			this.showSubtitleDetails = !this.showSubtitleDetails;
			this.showqueryDetails = false;
		},
		queryDetails() {
			this.showqueryDetails = !this.showqueryDetails;
			this.showSubtitleDetails = false;
		},
	},

	beforeDestroy() {
		document.removeEventListener("fullscreenchange", this.handleFullscreenOrientation);
		var DataToSend = {};
		DataToSend["video_id"] = this.videoid;
		DataToSend["status"] = 1;
		DataToSend["resumeTime"] = Math.trunc(this.player.currentTime());
		if (this.isPlaybackEnded == false) {
			this.$store.dispatch("setResumeVideo", DataToSend).then(() => {
				this.$store.dispatch("getResumeVideo");
			});
		}
		if (this.player) {
			this.player.dispose();
		}
		location.reload();
	},
};
</script>
<style lang="scss">
.safari-player {
	width: 100vw;
	height: 100vh;
}

.list-item .image-bg {
	transform: scale(1);
}

.list-item:hover .image-bg {
	transform: scale(1.2);
	transition: all 0.5s ease;
}

.vjs-button>.vjs-icon-placeholder:before {
	font-size: 2.8em !important;
	line-height: unset !important;
}

.vjs-button>.vjs-icon-placeholder:hover {
	color: #85b157 !important;
	transform: scale(1.2) !important;
}

.video-js .vjs-volume-panel .vjs-volume-control {
	color: #85b157 !important;
}

.video-js .vjs-play-progress {
	background-color: #85b157 !important;
}

.video-js .vjs-big-play-button {
	position: absolute !important;
	top: 42% !important;
	left: 45% !important;
}

.video-js .vjs-big-play-button {
	width: 75px !important;
	height: 80px !important;
	background-color: #85b157 !important;
	border-color: transparent !important;
	border-radius: 50% !important;
	font-size: 45px !important;
}

.video-js .vjs-volume-level {
	background-color: #85b157 !important;
}

.video-js .vjs-play-progress:before {
	color: #85b157 !important;
}

.backBtn {
	position: fixed;
	transform: translate(60%, 150%);
	z-index: 200;
	color: white !important;
	background-color: none;
	cursor: pointer;
	background: transparent;
	display: flex !important;
	justify-content: center !important;
	width: 27px;
	margin-top: 10px;
}

.cast-btn {
	position: absolute;
	right: 50px;
	transform: translate(60%, 150%);
	z-index: 200;
	color: white !important;
	background-color: none;
	cursor: pointer;
	background: transparent;
	width: 27px;
	margin-top: 10px;

	&:hover {
		color: #85b157 !important;
	}
}

.video-content-wrapper {
	height: 100%;
	background: rgba(10, 8, 5, 0.9);
}

.video-js .vjs-control-bar {
	background-color: transparent !important;
	display: flex;
	align-items: center;
	padding: 0px 20px;
	bottom: 100px !important;
}

.video-js .vjs-volume-panel {
	margin-right: 40px;
}

.video-js .vjs-volume-level {
	background-color: #679f3d !important;
}

.video-js .vjs-remaining-time {
	display: none;
}

.video-js.vjs-paused:not(.vjs-has-started) .vjs-loading-spinner {
	display: none;
}

.video-js .vjs-picture-in-picture-control {
	display: none;
}

.video-js .vjs-subs-caps-button {
	display: block;
}

.video-js .vjs-progress-holder {
	height: 10px !important;
	border-radius: 8px !important;
}

.video-js .vjs-slider {
	background-color: #ffffff !important;
}

.video-js .vjs-play-progress:before {
	font-size: 25px !important;
}

.video-js .vjs-quality-selector.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
	position: absolute;
	color: #f1f2f2;
	width: 130px;
	bottom: 1.5em;
	max-height: 230px;
	background: #8a8a8a80;
	opacity: 1;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: left;
	line-height: 26px;
	letter-spacing: 0;
	overflow: hidden;
}



.vjs-quality-selector .vjs-menu li.vjs-menu-title {
	text-align: center;
	font-size: 20px;
	line-height: 2em;
	padding: 0;
	margin: 0 0 0.3em 0;
	font-weight: bold;
	cursor: default;
}

.vjs-quality-selector .vjs-menu li {
	font-weight: normal;
	font-size: 16px !important;
	font-family: "averta-regular";
	color: #f1f2f2;

}

.vjs-quality-selector .vjs-menu li:hover {
	background: none;
}

.vjs-quality-selector .vjs-menu li.vjs-selected {

	font-weight: bold;
	margin-right: 50px !important;
	font-family: "averta-regular";
	color: #f1f2f2;
	background: none;
}

.vjs-quality-selector .vjs-menu li.vjs-selected :before {
	content: "\2713";
	display: inline-block;
	vertical-align: middle;
	line-height: 1em;
	width: auto;
	height: auto;
	margin-right: 0.5em;
	text-align: center;
	font-weight: bold;
	color: #f1f2f2;
}

.video-js .vjs-remaining-time {
	display: none;
}

.video-js .vjs-play-control .vjs-icon-placeholder:before,
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/play.svg") !important;
}

.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/pause1.png") !important;
}

.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/fullscreen.svg") !important;
}

.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/fullscreen-exit.png") !important;
}

.video-js .vjs-quality-selector .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/settings.svg") !important;
}

.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/subtitles.svg") !important;
}

.video-js .vjs-mute-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/volume-up.svg") !important;
}

.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/volume-down.png") !important;
}

.video-js .vjs-skipbackward-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/rewind.svg") !important;
}

.video-js .vjs-skipforward-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/fast forward.svg") !important;
}

.video-js .vjs-chromecast-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/cast.svg") !important;
}

.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/subtitles.svg") !important;
}

.video-js .vjs-questionbtn-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/helpoutline.svg") !important;
}

.video-js .vjs-subtitle-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/subtitles.svg") !important;
}

.video-js .vjs-backbtn-control .vjs-icon-placeholder:before {
	content: url("../../assets/img/av-icn/back\ button.svg") !important;
}

.video-js .vjs-icon-placeholder:before {
	cursor: pointer;
	transform: scale(1);
}

.video-js .vjs-icon-placeholder:hover::before {
	transform: scale(1.2);
}

.video-js .vjs-play-control {
	margin-right: 50px !important;
}

.video-js .vjs-skipforward-control {
	margin-right: 50px !important;
}

.video-js .vjs-skipbackward-control {
	margin-right: 50px !important;
}

.video-js .vjs-movienamebtn-control {
	font: bold 22px Averta-Regular;
	letter-spacing: 0px;
	color: #f1f2f2;
	opacity: 1;
	font-size: 14px;
	width: 150px !important;
}

.video-js .vjs-backbtn-control {
	position: fixed;
	top: 30px;
	left: 20px;
	height: 60px;
}

.video-js .vjs-fullscreen-control {
	position: absolute;
	bottom: 0;
	right: 50px;
}

.video-js .vjs-chromecast-control {
	position: absolute;
	bottom: 0;
	right: 150px;
}



.video-js .vjs-quality-selector {
	position: absolute;
	bottom: 0;
	right: 250px;
}

.video-js .vjs-questionbtn-control {
	position: absolute;
	bottom: 0;
	right: 450px;
}

.video-js .vjs-subtitle-control {
	position: absolute;
	bottom: 0;
	right: 350px;
}

.video-js .vjs-duration {
	display: block;
	position: absolute;
	top: -52px;
	right: 30px;
}

.video-js .vjs-play-progress:before {
	color: #679f3d !important;
}

.video-js .vjs-play-progress {
	background-color: #679f3d !important;

}

.video-js .vjs-progress-control {
	position: absolute;
	width: 92%;
	top: -4.3em;
	height: 3px;
	border-radius: 5px;
}

.video-js .vjs-progress-holder {
	position: absolute;
	margin: 0px;
	top: 0%;
	width: 100%;
}

.video-js .vjs-live-control {
	font-size: 22px;
	font: 600;
	color: #679f3d;
	line-height: 1;
	margin-left: 20px;
}

.video-content-wrapper.livestream .vjs-time-control.vjs-time-divider {
	display: none;
}

.video-content-wrapper.livestream .vjs-duration {
	display: none;
}

.video-content-wrapper.livestream .vjs-live .vjs-progress-control {
	display: block;
}

.video-js .vjs-playback-rate {
	display: none !important;
}

.vjs-playback-rate .vjs-playback-rate-value {
	display: none !important;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
	height: 70px !important;
	width: 70px !important;
	left: -3000em;
	transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
}

.video-js .vjs-time-control {
	color: #fff;
	font-weight: 400;
	font-size: .9em;
}

.video-js .vjs-load-progress div {
	background: #ffffff !important;
	border-radius: 5px;
}

.video-js .vjs-time-control {
	color: #fff;
	font-weight: 500;
	font-size: 15px !important;
	line-height: 2em !important;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
	height: 142px !important;
	width: 35px !important;
	left: -3000em;
	transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
	border-radius: 5px;
	top: -140px !important;
}

.video-js .vjs-volume-vertical {
	background-color: rgba(43, 51, 63, 0.3);
}

.vjs-volume-bar.vjs-slider-vertical {
	width: 8px;
	height: 120px;
	margin: 1.35em auto;
	border-radius: 5px;
}

.vjs-slider-vertical .vjs-volume-level {
	width: 8px;
}

.video-js .vjs-volume-level:before {
	font-size: 20px !important;
}

.vidName {
	position: absolute;
	left: 360px;
	bottom: 80px;
	font: bold 22px/31px Averta-Regular;
	letter-spacing: 0px;
	color: #f1f2f2;
	opacity: 1;
	font-size: 14px;

	&:hover {
		transform: scale(1.1);
	}
}

.vidBtnWrapper {
	position: relative;
}

.subtitleDetailContainer {
	border-radius: 5px;
	position: absolute;
	right: 250px;
	bottom: 135px;
	color: #f1f2f2;
	width: 260px;
	height: 70px;
	background: #8a8a8a80 no-repeat padding-box;
	opacity: 1;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	line-height: 8px;
}

.queryDetailContainer {
	position: absolute;
	right: 320px;
	bottom: 135px;
	color: #f1f2f2;
	width: 240px;
	height: 50px;
	background: #8a8a8a80 no-repeat padding-box;
	opacity: 1;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	line-height: 8px;
}
</style>
